import './App.css';
import ROICalculator from './ROICalculator';

function App() {
  return (
    <ROICalculator/>
  );
}

export default App;
